import { Injectable } from '@angular/core';
import { MemberQuery } from '../../account/member/member.query';
import { CustomerTag } from '../../account/member/models/customer-tag.model';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ClubTagQuery {
  constructor(private memberQuery: MemberQuery) {}

  selectUserHasTag(lookupTag: CustomerTag, checkValue: boolean = true) {
    return this.memberQuery
      .select((state) => (state.user ? state.user.customerTags : undefined))
      .pipe(map((userTags) => this.hasTag(lookupTag, userTags, checkValue)));
  }

  selectUserNotHasTag(lookupTag: CustomerTag, checkValue: boolean = true) {
    return this.selectUserHasTag(lookupTag, checkValue).pipe(map((hasTag) => !hasTag));
  }

  private hasTag(lookupTag: CustomerTag, userTags: CustomerTag[] | undefined, checkValue: boolean): boolean {
    if (!userTags || userTags.length === 0 || (!lookupTag.TagId && !lookupTag.TagName)) {
      return false;
    }

    let foundTag: CustomerTag | undefined;
    if (lookupTag.TagId) {
      foundTag = userTags.find((x) => x.TagId === lookupTag.TagId);
    } else {
      foundTag = userTags.find((x) => x.TagName === lookupTag.TagName);
    }

    if (checkValue && foundTag) {
      if (foundTag && foundTag.TagValue === lookupTag.TagValue) {
        return true;
      }
    } else {
      if (foundTag) {
        return true;
      }
    }
    return false;
  }
}
